import React from "react";
import { Card, Col, Row, Avatar, Typography, Image, Layout } from "antd";
import { EllipsisOutlined } from "@ant-design/icons";
import { useNavigate, useLocation } from "react-router-dom";

const { Meta } = Card;
const { Title } = Typography;
const { Header } = Layout;

const Epic = () => {
  const navigate = useNavigate();
  const navigateschool = () => {
    navigate("/schoolDetails");
  };
  return (
    <>
      <div>
        <Header style={{ backgroundColor: "#ffb948", height: "75px" }}>
          <Row align="middle" gutter={16}>
            <Col xs={8} sm={6} md={4} lg={6}>
              <a
                href="https://sriramanavami.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Image
                  preview={false}
                  src="/favicon.ico"
                />
              </a>
            </Col>
          </Row>
        </Header>
      </div>
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage:
            "url(https://easy-peasy.ai/cdn-cgi/image/quality=80,format=auto,width=700/https://fdczvxmwwjwpwbeeqcth.supabase.co/storage/v1/object/public/images/889e1b27-b887-4082-a896-b7921854ef78/722b627e-72e3-4422-80a7-aab78de2256e.png)",
          backgroundPosition: "center",
          backgroundSize: "cover",
          zIndex: -1,
        }}
      ></div>
      <div
        style={{
          padding: "50px",

          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Title
          level={2}
          style={{
            color: "#1e3a8a",
            marginBottom: "40px",
            textAlign: "center",
            letterSpacing: "2px",
          }}
        >
          EPIC COMPETITIONS
        </Title>

        <Row gutter={[32, 32]} style={{ width: "100%", maxWidth: "1000px" }}>
          <Col xs={24} sm={12}>
            <Card
              hoverable
              style={{
                borderRadius: "20px",
                overflow: "hidden",
                boxShadow: "0 8px 30px rgba(0, 0, 0, 0.1)",
              }}
              onClick={() => navigateschool()}
              cover={
                <img
                  alt="Student Quiz"
                  src="https://images.unsplash.com/photo-1509062522246-3755977927d7"
                  style={{ objectFit: "cover", height: "250px" }}
                />
              }
              actions={[<EllipsisOutlined key="ellipsis" />]}
            >
              <Meta
                avatar={
                  <Avatar src="https://randomuser.me/api/portraits/lego/2.jpg" />
                }
                title={
                  <span style={{ fontWeight: "bold", color: "#1e3a8a" }}>
                    Student Quiz
                  </span>
                }
                description="Join our interactive quiz and challenge yourself against the best minds!"
              />
            </Card>
          </Col>

          <Col xs={24} sm={12}>
            <Card
              hoverable
              style={{
                borderRadius: "20px",
                overflow: "hidden",
                boxShadow: "0 8px 30px rgba(0, 0, 0, 0.1)",
              }}
              onClick={() => navigateschool()}
              cover={
                <img
                  alt="Sloka Competition"
                  src="https://images.pexels.com/photos/5414344/pexels-photo-5414344.jpeg"
                  style={{ objectFit: "cover", height: "250px" }}
                />
              }
              actions={[<EllipsisOutlined key="ellipsis" />]}
            >
              <Meta
                avatar={
                  <Avatar src="https://randomuser.me/api/portraits/lego/5.jpg" />
                }
                title={
                  <span style={{ fontWeight: "bold", color: "#1e3a8a" }}>
                    Sloka Competition
                  </span>
                }
                description="Showcase your creativity by crafting the most innovative sloka!"
              />
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default Epic;
